import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { createSelectors } from '../utils/createSelector'
import { Office } from '../../components/firms/firm/mapper'

type UIState = {
  isApplicationFormModalOpen: boolean
  offerId: string | null
  offices: Office[] | null
  colorCareerSite: string | null
  isCareerSiteApply: boolean
}

type UIActions = {
  openApplicationFormModal: ({
    offerId,
    offices,
    colorCareerSite,
    isCareerSiteApply,
  }: {
    offerId?: string
    offices?: Office[]
    colorCareerSite?: string
    isCareerSiteApply?: boolean
  }) => void
  closeApplicationFormModal: () => void
}

const defaultState: UIState = {
  isApplicationFormModalOpen: false,
  offerId: null,
  offices: null,
  colorCareerSite: null,
  isCareerSiteApply: false,
}

export const useApplyStore = createSelectors(
  create<UIState & UIActions>()(
    immer((set) => ({
      ...defaultState,

      resetState: () => set(defaultState),

      openApplicationFormModal: ({
        offerId,
        offices,
        colorCareerSite,
        isCareerSiteApply,
      }: {
        offerId?: string
        offices?: Office[] | null
        colorCareerSite?: string
        isCareerSiteApply?: boolean
      }) =>
        set((state) => {
          state.isApplicationFormModalOpen = true
          state.offerId = offerId || null
          state.offices = offices || null
          state.colorCareerSite = colorCareerSite || null
          state.isCareerSiteApply = isCareerSiteApply || false
        }),

      closeApplicationFormModal: () =>
        set((state) => {
          state.isApplicationFormModalOpen = false
          state.offerId = null
          state.offices = null
          state.colorCareerSite = null
          state.isCareerSiteApply = false
        }),
    })),
  ),
)
